import React from "react";
import { Input as NBInput, IInputProps } from "native-base";

export const Input = (props: IInputProps) => {
  return <NBInput {...props}></NBInput>
};
